import React from 'react';

export function Lock() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        d="M5.3335 3.76471V5.64706H11.3335V3.76471C11.3335 2.20588 9.98975 0.941176 8.3335 0.941176C6.67725 0.941176 5.3335 2.20588 5.3335 3.76471ZM4.3335 5.64706V3.76471C4.3335 1.68529 6.12412 0 8.3335 0C10.5429 0 12.3335 1.68529 12.3335 3.76471V5.64706C13.4366 5.64706 14.3335 6.49118 14.3335 7.52941V14.1176C14.3335 15.1559 13.4366 16 12.3335 16H4.3335C3.23037 16 2.3335 15.1559 2.3335 14.1176V7.52941C2.3335 6.49118 3.23037 5.64706 4.3335 5.64706ZM3.3335 7.52941V14.1176C3.3335 14.6382 3.78037 15.0588 4.3335 15.0588H12.3335C12.8866 15.0588 13.3335 14.6382 13.3335 14.1176V7.52941C13.3335 7.00882 12.8866 6.58824 12.3335 6.58824H4.3335C3.78037 6.58824 3.3335 7.00882 3.3335 7.52941Z"
        fill="#9CA3AF"
      />
    </svg>
  );
}
